import React from 'react';
import { Container, Panel } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import { PageTitle } from 'components/PageTitle/PageTitle';

export function TireWheelModule() {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle title={t('Tire & Wheel Preferences')} />
      <Container>
        <Panel spacing={0}>
          <div>{t('Tire & Wheel Preferences content coming soon')}</div>
        </Panel>
      </Container>
    </>
  );
}
